var render = function () {
  var _vm$hide, _vm$hide2, _vm$hide3, _vm$hide4, _vm$product$price$bon, _vm$product$price, _vm$hide5, _vm$product, _vm$hide6, _vm$hide7;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', {
    staticClass: "product-card"
  }, [_c('LazyHydrate', {
    attrs: {
      "when-visible": ""
    }
  }, [_c('div', {
    staticClass: "product-card__wrapper",
    class: {
      'product-card__wrapper_adaptive': _vm.adaptive,
      'product-card__without-border': (_vm$hide = _vm.hide) === null || _vm$hide === void 0 ? void 0 : _vm$hide.includes('mobile-border')
    },
    style: {
      paddingTop: _vm.paddingTop,
      paddingRight: _vm.paddingRight,
      paddingBottom: _vm.paddingBottom,
      paddingLeft: _vm.paddingLeft
    }
  }, [!((_vm$hide2 = _vm.hide) !== null && _vm$hide2 !== void 0 && _vm$hide2.includes('mobile-more')) ? _c('div', {
    staticClass: "product-card__more",
    on: {
      "click": function ($event) {
        return _vm.enableProductMore({
          id: _vm.product.id,
          title: _vm.product.name,
          path: _vm.product.path
        });
      }
    }
  }) : _vm._e(), _vm._v(" "), !((_vm$hide3 = _vm.hide) !== null && _vm$hide3 !== void 0 && _vm$hide3.includes('desktop-tools')) ? _c('div', {
    staticClass: "product-card__tools",
    class: {
      'product-card__tools_active': _vm.isToolsActive
    }
  }, [_c('div', {
    staticClass: "product-card__tool product-card__tool_compare"
  }, [_c('div', {
    staticClass: "js-tool-tooltip"
  }, [_c('ActionCompare', {
    attrs: {
      "id": _vm.product.id,
      "product": _vm.product,
      "modal": {
        image: _vm.product.thumbnail.x1,
        link: _vm.product.path,
        name: _vm.product.name
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var add = _ref.add,
            remove = _ref.remove,
            active = _ref.active,
            loading = _ref.loading;
        return [_c('UserTool', {
          attrs: {
            "loading": loading,
            "active": active
          },
          on: {
            "add": add,
            "remove": remove
          }
        })];
      }
    }], null, false, 2641766758)
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "product-card__tool product-card__tool_favorite"
  }, [_c('div', {
    staticClass: "js-tool-tooltip"
  }, [_c('ActionFavorite', {
    attrs: {
      "id": _vm.product.id,
      "product": _vm.product,
      "list-name": _vm.source,
      "index": _vm.itemIndex
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var add = _ref2.add,
            remove = _ref2.remove,
            active = _ref2.active,
            loading = _ref2.loading;
        return [_c('UserTool', {
          attrs: {
            "type": "favorite",
            "active": active,
            "loading": loading
          },
          on: {
            "add": add,
            "remove": remove
          }
        })];
      }
    }], null, false, 2898338428)
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product-card__top-wrapper"
  }, [!((_vm$hide4 = _vm.hide) !== null && _vm$hide4 !== void 0 && _vm$hide4.includes('bonus')) && _vm.product.price && _vm.product.price.bonus > 10 || _vm.product.availableBonusPay === false ? _c('div', {
    staticClass: "product-card__bonus-wrap product-card__bonus-wrap_mobile"
  }, [_c('TSBonusCount', {
    attrs: {
      "count": (_vm$product$price$bon = (_vm$product$price = _vm.product.price) === null || _vm$product$price === void 0 ? void 0 : _vm$product$price.bonus) !== null && _vm$product$price$bon !== void 0 ? _vm$product$price$bon : 0,
      "description": true,
      "available-pay": _vm.product.availableBonusPay
    }
  })], 1) : _vm._e(), _vm._v(" "), Array.isArray(_vm.product.thumbnailArray) && _vm.product.thumbnailArray.length > 0 && !((_vm$hide5 = _vm.hide) !== null && _vm$hide5 !== void 0 && _vm$hide5.includes('product-card-slider')) ? _c('nuxt-link', {
    attrs: {
      "to": _vm.product.path || '#'
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.emit('product-select');
      }
    }
  }, [_c('TSProductCardSlider', {
    staticClass: "product-card__photo-slider",
    class: ("product-card__photo-slider_" + (_vm.mobileType)),
    attrs: {
      "image": _vm.product.thumbnailArray,
      "name": _vm.product.name
    }
  })], 1) : _c('nuxt-link', {
    staticClass: "product-card__photo-wrapper",
    attrs: {
      "to": _vm.product.path || '#'
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.emit('product-select');
      }
    }
  }, [_c('LazyImg', {
    staticClass: "product-card__photo",
    attrs: {
      "img": _vm.product.thumbnail.x1 || _vm.product.image,
      "srcset": _vm.product.thumbnail.x2,
      "alt": _vm.product.name,
      "disable": !_vm.photoLazyload
    }
  })], 1), _vm._v(" "), _vm.product.rate.rating ? _c('div', {
    staticClass: "product-card__rating"
  }, [_c('TSProductRating', {
    attrs: {
      "is-active": _vm.product.rate.rating,
      "size": "12"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_vm._v("\n            " + _vm._s(_vm.product.rate.rating)), _c('span', {
    staticClass: "grey-text"
  }, [_vm._v(" / " + _vm._s(_vm.product.rate.count))])])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "product-card__text-wrapper"
  }, [_c('div', {
    staticClass: "product-card__sale-marker"
  }, [!_vm.compact && _vm.product.sale.length ? _c('SaleMarkerList', {
    attrs: {
      "list": _vm.product.sale,
      "type": _vm.mobileType
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm$product = _vm.product) !== null && _vm$product !== void 0 && _vm$product.emptyPriceText ? _c('div', {
    staticClass: "product-card__empty-price"
  }, [_vm._v("\n          " + _vm._s(_vm.product.emptyPriceText) + "\n        ")]) : _vm.product.price && _vm.product.price.common && !((_vm$hide6 = _vm.hide) !== null && _vm$hide6 !== void 0 && _vm$hide6.includes('price')) ? _c('div', {
    staticClass: "product-card__price-wrap"
  }, [_c('div', {
    staticClass: "product-card__price"
  }, [_c('TSPrice', {
    attrs: {
      "price": _vm.product.price
    }
  })], 1), _vm._v(" "), !((_vm$hide7 = _vm.hide) !== null && _vm$hide7 !== void 0 && _vm$hide7.includes('bonus')) && _vm.product.price && _vm.product.price.bonus > 10 || _vm.product.availableBonusPay === false ? _c('div', {
    staticClass: "product-card__bonus-wrap"
  }, [_c('TSBonusCount', {
    attrs: {
      "count": _vm.product.price.bonus,
      "description": true,
      "available-pay": _vm.product.availableBonusPay
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.downPayment ? _c('div', {
    staticClass: "product-card__installment-wrap"
  }, [_c('div', {
    staticClass: "product-card__installment-value"
  }, [_vm._v("\n            " + _vm._s(_vm.formatPrice(_vm.downPayment)) + "₽\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "product-card__installment-text"
  }, [_vm._v("\n            в рассрочку\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product-card__title p"
  }, [_c('nuxt-link', {
    staticClass: "link link_wu",
    attrs: {
      "to": _vm.product.path || '#',
      "title": _vm.product.name
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.emit('product-select');
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.product.name) + "\n          ")])], 1), _vm._v(" "), !_vm.compact ? [_vm.mainPropertyArray.length ? _c('ul', {
    staticClass: "product-card__property-list"
  }, _vm._l(_vm.mainPropertyArray, function (prop, index) {
    return _c('li', {
      key: index,
      staticClass: "product-card__property-list-row"
    }, [_c('span', {
      staticClass: "product-card__property-list-prop"
    }, [_vm._v(_vm._s(prop.name) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "product-card__property-list-value"
    }, [_vm._v(_vm._s(prop.value))])]);
  }), 0) : _vm._e(), _vm._v(" "), _vm.product.rate.rating ? _c('div', {
    staticClass: "product-card__rating"
  }, [_c('TSProductRating', {
    attrs: {
      "is-active": _vm.product.rate.rating,
      "size": "12"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-5"
  }, [_vm._v("\n              " + _vm._s(_vm.product.rate.rating)), _c('span', {
    staticClass: "grey-text"
  }, [_vm._v(" / " + _vm._s(_vm.product.rate.count))])])], 1) : _vm._e(), _vm._v(" "), _c('ActionCart', {
    attrs: {
      "id": _vm.product.id,
      "product": _vm.product,
      "price": _vm.product.price && _vm.product.price.common.value,
      "source": _vm.source,
      "modal": {
        image: _vm.product.thumbnail.x1,
        link: _vm.product.path,
        name: _vm.product.name,
        price: _vm.product.price,
        category: _vm.product.category,
        offer: _vm.product.offer,
        id: _vm.product.id
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref3) {
        var _vm$hide8, _vm$product$status;

        var add = _ref3.add,
            increaseAmount = _ref3.increaseAmount,
            decreaseAmount = _ref3.decreaseAmount,
            quantity = _ref3.quantity,
            active = _ref3.active,
            loading = _ref3.loading;
        return [_c('div', {
          staticClass: "product-card__button"
        }, [_c('div', {
          staticClass: "product-card__button-row"
        }, [!((_vm$hide8 = _vm.hide) !== null && _vm$hide8 !== void 0 && _vm$hide8.includes('mobile-favorite')) ? _c('ActionFavorite', {
          attrs: {
            "id": _vm.product.id,
            "product": _vm.product
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref4) {
              var favoriteActive = _ref4.active,
                  favoriteAdd = _ref4.add,
                  favoriteRemove = _ref4.remove;
              return [_c('div', {
                staticClass: "product-card__toggle-favorite",
                class: [{
                  'product-card__toggle-favorite_active': favoriteActive
                }, {
                  'product-card__toggle-favorite_list': _vm.mobileType === 'list'
                }, {
                  'product-card__toggle-favorite_grid': _vm.mobileType === 'grid'
                }],
                on: {
                  "click": function ($event) {
                    favoriteActive ? favoriteRemove() : favoriteAdd();
                  }
                }
              })];
            }
          }], null, true)
        }) : _vm._e(), _vm._v(" "), ((_vm$product$status = _vm.product.status) === null || _vm$product$status === void 0 ? void 0 : _vm$product$status.code) === 'NOT_AVAILABLE' ? _c('div', {
          staticClass: "product-card__button-disabled"
        }, [_vm._v("\n                  Распродано\n                ")]) : _c('div', {
          staticClass: "product-card__button-wrap",
          class: [{
            'product-card__button-wrap_preorder': _vm.isPreOrder && !active && !loading
          }],
          attrs: {
            "data-e2e": "add-to-basket"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              active ? null : (add({
                quantity: 1,
                product: _vm.product
              }), _vm.emit('add-product'));
            }
          }
        }, [active ? _c('TSCounter', {
          attrs: {
            "quantity": quantity,
            "max": 999,
            "loading": loading
          },
          on: {
            "decrease": function ($event) {
              return decreaseAmount({
                quantity: $event
              });
            },
            "increase": function ($event) {
              return increaseAmount({
                quantity: $event
              });
            }
          }
        }) : _c('CartTool', {
          attrs: {
            "theme": _vm.isPreOrder && !active && !loading ? 'white' : 'black',
            "loading": loading
          }
        }, [_c('div', {
          staticClass: "product-card__button-text"
        }, [_vm._v("\n                      " + _vm._s(_vm.isPreOrder ? _vm.product.status.name : 'В корзину') + "\n                    ")])])], 1)], 1)])];
      }
    }], null, false, 188479660)
  })] : _vm._e()], 2)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }